<template>
  <div id="banner" :style="{'margin-top':marginTop}">
    <div class="bannerLayout" :style="{'backgroundImage':'url('+Layout+')'}">
      <div class="container flex flex-y fl">
        <div class="content">
          <div class="title">{{title}}</div>
          <p>{{desc}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "desc", "marginTop", "topValue"],
  data() {
    return {
      Layout: require("@/assets/images/public/banner.png")
    };
  }
};
</script>

<style lang="scss" scoped>
#banner {
  .bannerLayout {
    width: 100%;
    height: 230px;
    background-size: auto 100%;
    background-color: #4a65e4;
    background-position: 50%;
    background-repeat: no-repeat;
    overflow: hidden;
    .container {
      min-width: 800px;
      max-width: 800px;
      height: 100%;
      margin: 0 auto;
      position: relative;
      .content {
        .title {
          font-size: 32px;
          font-weight: bold;
          color: #fff;
          letter-spacing: 1px;
          // width: 170px;
        }
        p {
          letter-spacing: 1px;
          color: #fff;
          opacity: 0.8;
          font-size: 16px;
          margin-top: 8px;
          width: 160px;
        }
      }
    }
  }
}
</style>
